import { render, staticRenderFns } from "./fullFift.vue?vue&type=template&id=732cb6f9&scoped=true&"
import script from "./fullFift.vue?vue&type=script&lang=js&"
export * from "./fullFift.vue?vue&type=script&lang=js&"
import style0 from "./fullFift.vue?vue&type=style&index=0&id=732cb6f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732cb6f9",
  null
  
)

component.options.__file = "fullFift.vue"
export default component.exports